import React from 'react'
import DOMPurify from 'dompurify'

DOMPurify.addHook('afterSanitizeAttributes', function (node) {
  // set all elements owning target to target=_blank
  if ('target' in node) {
    node.setAttribute('target', '_blank')
    node.setAttribute('rel', 'noopener')
  }
})

const RawHtml = ({ content, ...props }) => (
  <div
    {...props}
    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
  />
)

export default RawHtml
